import { Breadcrumbs, Caption, Headline, Section } from "@telegram-apps/telegram-ui";
import { Link } from "@/components/Link/Link.tsx";
import { useTranslation } from "react-i18next";
import { useAuthProfile } from "@/providers/AuthProfileProvider.tsx";
import { IdeaCard } from "@/components/Idea/IdeaCard.tsx";
import { Page } from "@/components/Page.tsx";
import "../components/Idea/styles.css";

export const AllIdeasPage = () => {
  const { authProfile } = useAuthProfile();
  const { t } = useTranslation();

  if (!authProfile) {
    throw new Error("AllIdeasPage must be inside the AuthProfileProvider");
  }

  return (
    <Page>
      <div className="mr-3 ml-3 flex flex-col gap-3">
        <Breadcrumbs>
          <Breadcrumbs.Item>
            <Link to="/main">{t('navigation.main')}</Link>
          </Breadcrumbs.Item>
          <Breadcrumbs.Item>
            Идеи для подарков
          </Breadcrumbs.Item>
        </Breadcrumbs>

        <div className="pb-10">
          <Section>
            <div className="p-2 pl-5 pr-5 min-h-10">
              <Headline weight="1">Идеи для подарков</Headline>
            </div>

            {/* 2-column grid layout */}
            {authProfile.ideas.length > 0 ? (
              <div className="ideas-grid p-4">
                {authProfile.ideas.map((idea) => (
                  <IdeaCard key={idea.id} idea={idea} layout="grid" />
                ))}
              </div>
            ) : (
              <div className="p-5 text-center">
                <Caption className="text-color-hint">
                  Нет доступных идей
                </Caption>
              </div>
            )}
          </Section>
        </div>
      </div>
    </Page>
  );
};
